import React, {useState} from "react";
import SignInBaseLayout from "../../common/SignInBaseLayout";
import ForgotPasswordForm from "./ForgotPasswordForm";
import {ForgottenPasswordEmail, ForgottenPasswordStep, SuccessHandler} from "./types";
import SuccessForm from "./SuccessForm";

export const ForgottenPasswordContext = React.createContext<ForgottenPasswordEmail>({email: ""});

export default function ForgotPasswordView() {

  const [currentStep, setCurrentStep] = useState<ForgottenPasswordStep>(ForgottenPasswordStep.ENTER_EMAIL)
  const [currentEmail, setCurrentEmail] = useState<ForgottenPasswordEmail>({email: ""})

  const successHandler: SuccessHandler = {
    onSuccess: (forgottenPasswordEmail: ForgottenPasswordEmail) => {
      setCurrentEmail(forgottenPasswordEmail);
      setCurrentStep(ForgottenPasswordStep.SUCCESS);
    },
  }

  return (
    <SignInBaseLayout headline_i18n={currentStep.valueOf()} subtitle_i18n={currentStep.valueOf() + "_subtitle"}>
      <ForgottenPasswordContext.Provider value={currentEmail}>
        {currentStep === ForgottenPasswordStep.ENTER_EMAIL && (<ForgotPasswordForm successHandler={successHandler}/>)}
        {currentStep === ForgottenPasswordStep.SUCCESS && (<SuccessForm/>)}
      </ForgottenPasswordContext.Provider>
    </SignInBaseLayout>
  );
}
